import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-full min-h-0 flex-col" }
const _hoisted_2 = { class: "-mx-6 mb-4 flex items-center justify-between border-b border-concrete-200 px-6 pb-6" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "scrollbar-hide min-h-0 flex-1 space-y-6 overflow-y-auto px-1 pb-2" }
const _hoisted_5 = { class: "mb-3 font-primary text-base font-bold text-orange-600" }
const _hoisted_6 = { class: "mb-3 font-primary text-base font-bold text-orange-600" }
const _hoisted_7 = { class: "mb-3 flex items-center gap-1.5 font-primary text-base font-bold text-orange-600" }
const _hoisted_8 = { class: "group relative inline-flex" }
const _hoisted_9 = { class: "pointer-events-none absolute bottom-full left-0 z-10 mb-2 hidden w-56 rounded-lg border border-concrete-300 bg-white p-3 text-xs font-normal text-black shadow-lg group-hover:block" }
const _hoisted_10 = { class: "mb-2 block font-bold" }
const _hoisted_11 = { class: "mb-3 block" }
const _hoisted_12 = { class: "mb-2 block font-bold" }
const _hoisted_13 = { class: "block" }
const _hoisted_14 = { class: "grid grid-cols-2 gap-x-4" }
const _hoisted_15 = { class: "mb-3 flex items-center gap-1.5 font-primary text-base font-bold text-orange-600" }
const _hoisted_16 = { class: "group relative inline-flex" }
const _hoisted_17 = { class: "pointer-events-none absolute bottom-full left-0 z-10 mb-2 hidden w-56 rounded-lg border border-concrete-300 bg-white p-3 text-xs font-normal text-black shadow-lg group-hover:block" }
const _hoisted_18 = { class: "mb-2 flex items-center gap-1 font-bold" }
const _hoisted_19 = { class: "mb-3 block" }
const _hoisted_20 = { class: "mb-2 flex items-center gap-1 font-bold" }
const _hoisted_21 = { class: "block" }
const _hoisted_22 = { class: "grid grid-cols-2 gap-x-4" }

import { getTranslation, getGlobalTranslation } from "~/js/composables/translations";
import { getIcon, getLocationIconTypes } from "~/js/composables/icons";

import type { Translations } from "~/js/interfaces/translations";

import FilterLocationDistance from "~/vue/molecules/filters/FilterLocationDistance.vue";
import FilterLocationAreaRange from "~/vue/molecules/filters/FilterLocationAreaRange.vue";
import FilterLocationOption from "~/vue/molecules/filters/FilterLocationOption.vue";
import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";
import ButtonQuarternary from "~/vue/atoms/buttons/ButtonQuarternary.vue";
import TextH5 from "~/vue/atoms/texts/TextH5.vue";

interface Props {
	translations?: Translations | null;
	loading: boolean;
	distanceLabel: string;
	checkedValue: (field: string) => boolean;
	checkTypeValue: (field: string, value: string) => boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterLocationsPanel',
  props: {
    translations: { default: null },
    loading: { type: Boolean },
    distanceLabel: {},
    checkedValue: {},
    checkTypeValue: {}
  },
  emits: ["close", "clearAll", "setFacet"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const t = (key: string) => getTranslation(props.translations ?? {}, key);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(TextH5, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(getGlobalTranslation)("Filters")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ButtonQuarternary, {
          content: _unref(getGlobalTranslation)('Clear filters'),
          size: "small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clearAll')))
        }, null, 8, ["content"]),
        _createVNode(ButtonSecondary, {
          icon: "times",
          size: "small",
          class: "lg:hidden",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", null, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(__props.distanceLabel), 1),
        _createVNode(FilterLocationDistance, {
          label: __props.distanceLabel,
          loading: __props.loading
        }, null, 8, ["label", "loading"])
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(getGlobalTranslation)("Rentable surface")), 1),
        _createVNode(FilterLocationAreaRange)
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("h3", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(t("Availability")), 1),
          _createElementVNode("span", _hoisted_8, [
            _cache[6] || (_cache[6] = _createElementVNode("i", {
              class: "fas fa-question-circle text-sm text-concrete-700",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(getGlobalTranslation)("Available now")), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(getGlobalTranslation)("Available within 6 months.")), 1),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(getGlobalTranslation)("Available soon")), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getGlobalTranslation)("Available starting from 6 months from now.")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(FilterLocationOption, {
            label: t('Available now'),
            checked: __props.checkedValue('availableNow'),
            loading: __props.loading,
            onToggle: _cache[2] || (_cache[2] = ($event: any) => (emit('setFacet', { field: 'availableNow', value: !__props.checkedValue('availableNow') })))
          }, null, 8, ["label", "checked", "loading"]),
          _createVNode(FilterLocationOption, {
            label: t('Available soon'),
            checked: __props.checkedValue('availableSoon'),
            loading: __props.loading,
            onToggle: _cache[3] || (_cache[3] = ($event: any) => (emit('setFacet', { field: 'availableSoon', value: !__props.checkedValue('availableSoon') })))
          }, null, 8, ["label", "checked", "loading"])
        ])
      ]),
      _createElementVNode("section", null, [
        _createElementVNode("h3", _hoisted_15, [
          _createElementVNode("span", null, _toDisplayString(_unref(getGlobalTranslation)("Type")), 1),
          _createElementVNode("span", _hoisted_16, [
            _cache[7] || (_cache[7] = _createElementVNode("i", {
              class: "fas fa-question-circle text-sm text-concrete-700",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("span", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, [
                _createElementVNode("i", {
                  class: _normalizeClass(`${_unref(getIcon)(_unref(getLocationIconTypes)('project'))}`)
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_unref(getGlobalTranslation)("Project")), 1)
              ]),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(getGlobalTranslation)("Build the perfect distribution centre.")), 1),
              _createElementVNode("span", _hoisted_20, [
                _createElementVNode("i", {
                  class: _normalizeClass(`${_unref(getIcon)(_unref(getLocationIconTypes)('building'))}`)
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(_unref(getGlobalTranslation)("Building")), 1)
              ]),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(getGlobalTranslation)("Existing warehouses that match your operational requirements.")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(FilterLocationOption, {
            label: _unref(getGlobalTranslation)('Project'),
            checked: __props.checkTypeValue('type', 'project'),
            loading: __props.loading,
            onToggle: _cache[4] || (_cache[4] = ($event: any) => (emit('setFacet', { field: 'type', value: 'project' })))
          }, null, 8, ["label", "checked", "loading"]),
          _createVNode(FilterLocationOption, {
            label: _unref(getGlobalTranslation)('Building'),
            checked: __props.checkTypeValue('type', 'building'),
            loading: __props.loading,
            onToggle: _cache[5] || (_cache[5] = ($event: any) => (emit('setFacet', { field: 'type', value: 'building' })))
          }, null, 8, ["label", "checked", "loading"])
        ])
      ])
    ])
  ]))
}
}

})